import React, { useState } from "react";
import { FaRupeeSign, FaCalendarAlt, FaMoneyCheckAlt, FaExchangeAlt } from "react-icons/fa";
import "./PaymentHistory.css";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import axios from "axios";
import { useDispatch } from "react-redux";
import { ERROR } from "../../../redux/actionType";
import { toast } from "react-toastify";
import { getSingleTrancheData } from "../../../redux/TrancheReducer/action";
import { useParams } from "react-router-dom";
import { Badge } from "react-bootstrap";
import { getAuthToken } from "../../../utils/auth";

const PaymentHistory = ({ trancheData }) => {
  // const [payments, setPayments] = useState([
  //   {
  //     id: 1,
  //     amount: 25000,
  //     mode: "Bank Transfer",
  //     reference: "TXN123456789",
  //     date: "2025-01-15",
  //   },
  //   {
  //     id: 2,
  //     amount: 25000,
  //     mode: "Online Payment",
  //     reference: "UPI987654321",
  //     date: "2024-01-15",
  //   },
  //   {
  //     id: 3,
  //     amount: 25000,
  //     mode: "Bank Transfer",
  //     reference: "PAY456789123",
  //     date: "2024-01-15",
  //   },
  // ]);

  // const payments = trancheData?.payment_history?.transactions || [];
  const payments = trancheData?.payment_history || [];
  // const paymentHistoryPagination = trancheData?.payment_history?.pagination || {};
  const [loading, setLoading] = useState(false);

  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  const dispatch = useDispatch();

  const { trancheStatus } = useParams();

  const [currentTransactionsPage, setCurrentTransactionsPage] = useState(parseInt(sessionStorage.getItem('currentTransactionsPage')) || 1);
  const [transactionsLimit, setTransactionsLimit] = useState(parseInt(sessionStorage.getItem('transactionsLimit')) || 10);
  const totalTransactionsCount = parseInt(sessionStorage.getItem('totalTransactionsCount')) || 0;
  const totalTransactionsPages = Math.ceil(totalTransactionsCount / transactionsLimit);

  const [formData, setFormData] = useState({
    tranche_id: trancheData?.tranche_id,
    amount: "",
    mode_of_payment: "",
    transfer_reference_id: "",
    payment_date: "",
  });

  React.useEffect(() => {
    if (trancheData?.tranche_id) {
      setFormData((prev) => ({
        ...prev,
        tranche_id: trancheData.tranche_id,
      }));
    }
  }, [trancheData?.tranche_id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTransactionsPageChange = (newPage) => {
      // Ensure we're working with 1-based pagination
      const pageToSet = Math.max(1, Math.min(newPage, totalTransactionsPages));
      setCurrentTransactionsPage(pageToSet);
      sessionStorage.setItem('currentTransactionsPage', pageToSet.toString());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.amount || !formData.mode_of_payment || !formData.transfer_reference_id || !formData.payment_date || !formData.tranche_id) {
      toast.error("Please fill in all required fields");
      return;
    }

    // const newPayment = {
    //   ...formData,
    //   amount: parseFloat(formData.amount),
    // };

    console.log({ formData });

    if (!authToken) {
        // dispatch({ type: ERROR });
        toast.error(`Invalid or missiing token`);
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    try {
      setLoading(true);

      let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payment_allocations/create-manual-tranche-payment`, formData, { headers });

      toast.success("Payment successfully recorded");

      dispatch(getSingleTrancheData(trancheData?.tranche_id));

    } catch (error) {
        let errorMsg = error?.response?.data?.message;
        dispatch({ type: ERROR })

        toast.error(errorMsg);
    }
    finally {
      setLoading(false);
    }

    // setPayments([newPayment, ...payments]);
    setFormData({ 
      amount: "", 
      mode_of_payment: "", 
      transfer_reference_id: "", 
      payment_date: "", 
      tranche_id: trancheData?.tranche_id 
    });
  };

  console.log({ trancheData });

  return (
    <div className="payment-history-container">
      {/* Record Payment Form */}
      {trancheStatus !== "closed" && <div className="payment-form-card">
        <h3>Record Payment</h3>
        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>

          <div className="form-group">
            <label>
              Mode of Payment
            </label>
            <input
              type="text"
              name="mode_of_payment"
              value={formData.mode_of_payment}
              onChange={handleChange}
              placeholder="UPI"
            />
            {/* <select name="mode" value={formData.mode} onChange={handleChange}>
              <option value="">Select payment mode</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Online Payment">Online Payment</option>
              <option value="Cash">Cash</option>
              <option value="Cheque">Cheque</option>
            </select> */}
          </div>

          <div className="form-group">
            <label>
              Transfer Reference ID
            </label>
            <input
              type="text"
              name="transfer_reference_id"
              value={formData.transfer_reference_id}
              onChange={handleChange}
              placeholder="TXNREF12345"
            />
          </div>

          <div className="form-group">
            <label>
              Payment Date
            </label>
            <input
              type="date"
              name="payment_date"
              value={formData.payment_date}
              onChange={handleChange}
            />
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() =>
                setFormData({ amount: "", mode_of_payment: "", transfer_reference_id: "", payment_date: "", tranche_id: trancheData?.tranche_id })
              }
            >
              Cancel
            </button>
            <button type="submit" className="tranche-submit-btn" disabled={loading || trancheData?.status === "Closed"}>
              {/* Record Payment */}
               {loading ? "Recording Payment..." : "Record Payment"}
            </button>
          </div>
        </form>
      </div>}

      {/* Recent Payment Table */}
      <div className="payment-table-card">
        <h3>Recent Payment</h3>

        <div className="payment-legend-container">
          Type: &nbsp;&nbsp; 
          <span>
            <span
              style={{
                display: "inline-block",
                padding: "3px 16px",
                borderRadius: "999px",
                background: "#f5eaea",
                color: "#b22222",
                fontSize: "14px",
                fontWeight: 400,
                textTransform: "capitalize",
              }}
            >
              Debit
            </span> - SEEDS disburses to customer
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span>
            <span
              style={{
                display: "inline-block",
                padding: "3px 16px",
                borderRadius: "999px",
                background: "#dfe8d2",
                color: "#3b6b1a",
                fontSize: "14px",
                fontWeight: 400,
                textTransform: "capitalize",
              }}
            >
              Credit
            </span> - Customer pays back / refund recorded
          </span>
        </div>

        <div className="payment-table-container">
          <table className="payment-table">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Type</th>
                <th>Mode of Payment</th>
                <th>Transfer Reference</th>
                <th>Status</th>
                <th>Entity Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {/* {payments?.map((p) => (
                <tr key={p.id}>
                  <td>₹{p.amount.toLocaleString()}</td>
                  <td>{p?.mode_of_payment}</td>
                  <td>{p?.merchant_order_id}</td>
                  <td>{p?.transaction_status}</td>
                  <td>{p?.created_at?.split('T')[0]}</td>
                </tr>
              ))} */}
              {payments?.map((p) => {
                const isDebit = p?.debit_credit_flag === "DEBIT";
  
                return (
                  <tr key={p.id}>
                    <td>₹{p?.payment_amount?.toLocaleString()}</td>
                    <td>
                      <span className={`leadStatusBadge status-${p?.debit_credit_flag?.toLowerCase()?.replace('_', '-')}`}>
                        <span className="statusDot"></span>
                        {p?.debit_credit_flag}
                      </span>
                    </td>
                    <td>{p?.payment_mode}</td>
                    <td>{p?.order_id}</td>
                    <td>
                      <span className={`leadStatusBadge status-${p?.payment_status?.toLowerCase()?.replace('_', '-')}`}>
                        <span className="statusDot"></span>
                        {p?.payment_status}
                      </span>
                    </td>
                    <td>
                      <span className={`leadStatusBadge status-${p?.entity_type?.toLowerCase()?.replace('_', '-')}`}>
                        <span className="statusDot"></span>
                        {p?.entity_type}
                      </span>
                    </td>
                    {/* <td>{p?.created_at?.split('T')[0]}</td> */}
                    <td>{
                      new Date(p?.created_at).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                )})
              }
            </tbody>
          </table>
        </div>

        {/* <CustomPagination 
            currentPage={currentTransactionsPage}
            totalPages={totalTransactionsPages}
            onPageChange={handleTransactionsPageChange}
        /> */}
      </div>
    </div>
  );
};

export default PaymentHistory;